// src/ReusableFunctions/deepLinkTimestamp.js
export function parseDeepLinkTimestamp(search) {
  const params = new URLSearchParams(search || "");
  const t = params.get("t");
  const src = params.get("src");
  if (!t || !src) return null;
  const seconds = Number(t);
  if (!Number.isFinite(seconds) || seconds < 0) return null;
  return { src, seconds };
}
